

export function getUrlParameter(name, search) {
    name = name.replace(/\[/, '\\[').replace(/]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');

    var results = regex.exec(search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}



// WEBPACK FOOTER //
// ./src/util/DataUtils.js